import ScalarIconArrowDownLeft_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowDownLeft.vue.script.js";
//#region src/components/ScalarIconArrowDownLeft.vue
var ScalarIconArrowDownLeft_default = ScalarIconArrowDownLeft_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowDownLeft_default as default };

//# sourceMappingURL=ScalarIconArrowDownLeft.js.map